import { useParams } from "react-router-dom";
import EventOccasionService from "../../../services/EventOccasionService";
import { EventOccasion } from "../../../models";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import Breadcrumbs from "../../../components/breadcrumbs";
import EventOccasionEditForm from "./ui/event-occasion-edit-form";
import EventOccasionSkeleton from "./skeleton/event-occasion-skeleton";

export default function EventOccasionEditPage(){
     const { id } = useParams();
      const api = new EventOccasionService();
      const [eventOccasion, setEventOccasion] = useState<EventOccasion>();
      const [loading, setLoading] = useState(true);
      useEffect(() => { 
        fetchEventOccasion();
      }, []);
      console.log({id})
      const fetchEventOccasion = async () => {
        if (id) {
          const data = await api.getEventOccasionById(id);
          setEventOccasion(data);
          setLoading(false);
          
        }
      };

      if (!eventOccasion && !loading) return <NotFound message="Event Occasion not found." />;
    
      return (
        <main className="max-w-3xl ">
          <Breadcrumbs
            breadcrumbs={[
              { label: "Event Occasions", href: "/admin/event-occasions" },
              {
                label: "Edit",
                href: `/admin/event-occasions/edit/${id}`,
                active: true,
              },
            ]}
          />
          {!loading && eventOccasion ? (
            <EventOccasionEditForm eventOccasion={eventOccasion} />
          ) : (
            <EventOccasionSkeleton />
          )}
        </main>
      );
    }



